import { isMobilePhone, required } from "@/utils/inputValidators";
import { InputField } from "@clover/rrs-components/components/_form/InputField/InputField";
import { localizedPhoneComponentType } from "./localizedTypes";
import { localeOptions } from "./localizationData";

/**
 * LocalizedPhoneInput is a component that displays input box that accepts a phone number with
 * localized way of presenting it, including area anc country codes
 * @param locale    {PhoneLocale}  - current localization code
 * @param value     {string}       - current phone number if known
 * @param name     {string}       - identifier for the form
 * @param form      {string}       - form (?)
 * @param readOnly  {boolean}      - if the field is read only
 * @returns visual component to enter/display localized phone number
 */
const LocalizedPhoneInput = ({
  locale = "en-US",
  value,
  form,
  readOnly,
  name,
}: localizedPhoneComponentType) => {
  // pull only the locale we want to use, ignoring the rest.
  const currentLocaleOption = localeOptions[locale] || localeOptions["en-US"]!;

  return (
    <>
      <InputField
        key="phone"
        debounceTime={0}
        label="Phone Number"
        name={name || "phoneNumber"}
        type="format"
        placeholder={currentLocaleOption.placeholder}
        format={currentLocaleOption.format}
        form={form}
        theme={{
          width: "100%",
        }}
        validator={{
          isMobilePhone: isMobilePhone(locale),
          required: required("Phone Number"),
        }}
        readOnly={readOnly}
      />
    </>
  );
};

export default LocalizedPhoneInput;
